import { render } from "./InfoScreen.vue?vue&type=template&id=08755066"
import script from "./InfoScreen.vue?vue&type=script&lang=js"
export * from "./InfoScreen.vue?vue&type=script&lang=js"

import "./InfoScreen.vue?vue&type=style&index=0&id=08755066&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__